import { useEffect, useState, type FormEvent, type ReactNode } from "react";

type Access = "checking" | "allowed" | "login";

async function checkAccess(): Promise<"allowed" | "login"> {
  try {
    const response = await fetch("/api/stage-maker/session", { credentials: "include" });
    if (response.status === 401) return "login";
    if (response.ok && response.headers.get("Content-Type")?.includes("application/json")) return "allowed";
    return "allowed";
  } catch {
    return "allowed";
  }
}

async function login(password: string): Promise<void> {
  const response = await fetch("/api/stage-maker/login", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ password }),
  });
  if (!response.ok) throw new Error("パスワードが違います");
}

export function StageMakerGate({ children }: { children: ReactNode }) {
  const [access, setAccess] = useState<Access>("checking");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => { void checkAccess().then(setAccess); }, []);

  if (access === "checking") return <p className="maker-hub">確認中</p>;
  if (access === "allowed") return children;
  return (
    <div className="stage maker-page">
      <div className="device">
        <main className="maker-hub">
          <p className="editor-kicker">PRIVATE STAGE MAKER</p>
          <h1>ログイン</h1>
          <form onSubmit={(event: FormEvent) => {
            event.preventDefault();
            setError(null);
            void login(password)
              .then(() => setAccess("allowed"))
              .catch((cause: unknown) => setError(cause instanceof Error ? cause.message : "認証に失敗しました"));
          }}>
            <label className="field">パスワード
              <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} autoFocus />
            </label>
            {error ? <p className="map-issues" role="alert">{error}</p> : null}
            <button className="btn btn-primary" type="submit">開く</button>
          </form>
        </main>
      </div>
    </div>
  );
}
